import styles from './PulsingTriangles.module.scss';

const PulseTriangle = () => {
  return (
    <div className={styles.pulse}>
      <svg
        width="36"
        height="24"
        viewBox="0 0 36 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M24 12L6 22.3923V1.6077L24 12Z" fill="#E3D1FD" fillOpacity="0.5" />
        <path d="M30 12L12 22.3923V1.6077L30 12Z" fill="#C6A3FB" />
        <path d="M36 12L18 22.3923V1.6077L36 12Z" fill="#7F30F5" />
      </svg>
    </div>
  );
};

export default PulseTriangle;
